import { IGridServerSideDatasource, toQuery, IServerSideGetRowsParams } from "@samc/centricity-core";
import { AjaxHelper, IPaginatedList } from "@samc/common";
import { ILoanImportedForSameSeller, ILoanImportedForSameSellerFilter } from "../Interfaces";
import { download } from "../utils";

export class LoanImportedForSameSellerSource implements IGridServerSideDatasource {
  private _helper: AjaxHelper;
  public pageSize = 50;
  public cacheSize = 10;
  public adhocFilter: string = '';

  public isDifferentSeller?: boolean;
  public isDifferentPackage?: boolean;

  public lastQuery: ILoanImportedForSameSellerFilter = {};

  public constructor(private _eventId: number, private verificationToken: string | null = null) {
    this._helper = new AjaxHelper('/datasource/importdetails/sameseller', verificationToken, null, null);
  }

  public async getRows(params: IServerSideGetRowsParams) {
    try {
      const query = toQuery(params) as ILoanImportedForSameSellerFilter;
      query.eventId = this._eventId;
      this.lastQuery = query;

      const result = await this._helper.getData<IPaginatedList<ILoanImportedForSameSeller>>('', query);
      params.success({ rowData: result.items, rowCount: result.fullCount });
    } catch {
      params.fail();
    }
  }

  public async export() {
    const helper = new AjaxHelper('/datasource/importdetails/sameseller/export', this.verificationToken, null, null);
    const data = await helper.getData<Blob>('', this.lastQuery, { responseType: 'blob' });
    download(data, 'DuplicateLoansExport.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
  }
}